/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Color_FcInputs */

const en_fc_cmp_color_fc = /** @type {(inputs: Fc_Cmp_Color_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curves, wheels, HSL, LUTs, HDR/log, scopes`)
};

/**
* | output |
* | --- |
* | "Curves, wheels, HSL, LUTs, HDR/log, scopes" |
*
* @param {Fc_Cmp_Color_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_color_fc = /** @type {((inputs?: Fc_Cmp_Color_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Color_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_color_fc(inputs)
});
export { fc_cmp_color_fc as "fc.cmp.color.fc" }